export default __webpack_public_path__ + "static/media/e4.c0bfc826.png";